export default "__VITE_ASSET__BxOiS859__"